import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AzFooter } from "./AzFooter";
import { useHomeFeed } from "./useHomeFeed";
import "./azhome.css";
import "./azpages.css";

const AZ_PAGES = [/^\/(login|register|forgot-password|verify-email|contact)(\/|$)/, /^\/p\//, /^\/blogs/, /^\/list-your-token/, /^\/insurance-fund/, /^\/imrio/, /^\/leaderboard/];
export const isAzPage = (path) => AZ_PAGES.some((r) => r.test(path));

// Dark Azbit chrome for public info pages: black body + Azbit footer.
export const AzPageFooter = () => {
  const { pathname } = useLocation();
  const on = isAzPage(pathname);
  const feed = useHomeFeed();
  useEffect(() => {
    document.body.classList.toggle("az-page", on);
    return () => document.body.classList.remove("az-page");
  }, [on]);
  return on ? <AzFooter apps={feed?.apps} contact={feed?.contact} /> : null;
};
